/**
 * Realtime event handler for the /realtime namespace.
 *
 * Listens for server-pushed events (notifications, network updates)
 * and dispatches to the appropriate Pinia stores.
 *
 * Call initRealtime() once from App.vue after the user authenticates.
 */
import { getNamespaceSocket } from './useSocket'
import { useUsersStore, useReservationsStore } from '@/stores'

let initialized = false

/**
 * Connect the /realtime namespace and register event listeners.
 * Safe to call multiple times — only initializes once.
 */
export function initRealtime() {
  if (initialized) return

  const socket = getNamespaceSocket('/realtime')
  if (!socket) return

  initialized = true
  const usersStore = useUsersStore()
  const reservationsStore = useReservationsStore()

  socket.on('notification', notification => {
    if (usersStore.myUser?.notifications) {
      usersStore.myUser.notifications.push(notification)
    }
  })

  socket.on('network_update', () => {
    usersStore.refreshNetwork()
  })

  socket.on('reservation_status_changed', payload => {
    reservationsStore.handleReservationStatusChanged(payload)
  })

  socket.on('connect_error', err => {
    console.error('Realtime socket connect error', err.message)
  })

  socket.connect()
}

/**
 * Reset initialization state (called on logout so next login re-initializes).
 */
export function resetRealtime() {
  initialized = false
}
